<template>
  <v-app>
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar"
      timeout="800" :value="true" color="warning" absolute outlined top right>
      <v-icon class="mr-2" color="warning">mdi-alert-outline</v-icon>
      {{ errMsg }}
      <v-icon @click="snackbar = false" class="float-right" color="warning">mdi-close-circle</v-icon>

    </v-snackbar>
    <v-container class="pa-0 pa-sm-3 pa-md-3">
      <div class="px-sm-4">
        <v-toolbar dense class="elevation-0 mb-4 mt-6 pr-4">
          <v-toolbar-title>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold headline">Revenue</v-list-item-title>
                <v-list-item-subtitle class="body-1 mb-0 mt-1" color="#878B93">
                  The amount of money earned from sales or services.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-select :disabled="revloader" color="#3B82F6" v-if="revtab == 1 ? modeis != 'r': null " @change="clientFilter"
            style="max-width: 160px" outlined class="mr-4 mt-2 rounded-lg" dense :items="['All', 'AP', 'RM', 'Direct']"
            label="Clients" v-model="clientstype" hide-details></v-select>
          <v-text-field :disabled="revloader" color="#3B82F6" v-if="revtab == 0"
            class="mr-4 mt-9 rounded-lg d-none d-md-flex" style="max-width: 160px" dense outlined flat label="Search"
            v-model="daysearchText" prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <div v-else-if="modeis != 'r'">
            <v-text-field :disabled="revloader" color="#3B82F6" v-if="clientstype == 'All'"
              class="mr-4 mt-9 rounded-lg d-none d-md-flex" style="max-width: 160px" dense outlined flat label="Search"
              v-model="searchText" prepend-inner-icon="mdi-magnify">
            </v-text-field>
            <v-text-field :disabled="revloader" color="#3B82F6" v-else-if="clientstype == 'Direct'"
              class="mr-4 mt-9 rounded-lg d-none d-md-flex" style="max-width: 160px" dense outlined flat label="Search"
              v-model="searchText" prepend-inner-icon="mdi-magnify">
            </v-text-field>
            <v-autocomplete color="#3B82F6" :disabled="revloader" v-else @change="clisFilter" style="max-width: 160px"
              outlined class="mr-4 mt-2 rounded-lg" dense :items="clisitems" label="AP/RM filter" v-model="clisimodel"
              hide-details></v-autocomplete>
          </div>
          <v-text-field :disabled="revloader" color="#3B82F6" v-if="revtab == 1 ? modeis == 'r' : null "
              class="mr-4 mt-9 rounded-lg d-none d-md-flex" style="max-width: 160px" dense outlined flat label="Search"
              v-model="searchText" prepend-inner-icon="mdi-magnify">
            </v-text-field>

          <div>
            <v-tooltip open-delay="400" color="black" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-card v-bind="attrs" v-on="on" :color="`${daytabval == 'current_month' ? '#EFF6FF' : ''}`"
                  :disabled="revloader" @click="daytableFilter((val = 'current_month'))" width="40px" outlined
                  class="mt-2 py-2 elevation-0 rounded-l-lg rounded-0 text-center">
                  <span :style="`color:${daytabval == 'current_month' ? '#3B82F6' : 'black'
                    };`" class="caption">CM</span>
                </v-card>
              </template>
              <span>Current month</span>
            </v-tooltip>
          </div>
          <div>
            <v-tooltip open-delay="400" color="black" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-card v-bind="attrs" v-on="on" :color="`${daytabval == 'last_month' ? '#EFF6FF' : ''}`"
                  :disabled="revloader" @click="daytableFilter((val = 'last_month'))" width="40px" outlined
                  class="mt-2 py-2 elevation-0 rounded-0 text-center">
                  <span :style="`color:${daytabval == 'last_month' ? '#3B82F6' : 'black'
                    };`" class="caption">LM</span>
                </v-card>
              </template>
              <span>Last month</span>
            </v-tooltip>
          </div>
          <v-card :color="`${daytabval == 'three_months' ? '#EFF6FF' : ''}`" :disabled="revloader"
            @click="daytableFilter((val = 'three_months'))" width="40px" outlined
            class="mt-2 py-2 elevation-0 rounded-0 text-center">
            <span :style="`color:${daytabval == 'three_months' ? '#3B82F6' : 'black'
              };`" class="caption">3M</span>
          </v-card>
          <v-card :color="`${daytabval == 'six_months' ? '#EFF6FF' : ''}`" @click="daytableFilter((val = 'six_months'))"
            :disabled="revloader" width="40px" outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
            <span :style="`color:${daytabval == 'six_months' ? '#3B82F6' : 'black'};`" class="caption">6M</span>
          </v-card>
          <v-card :color="`${daytabval == 'one_year' ? '#EFF6FF' : ''}`" @click="daytableFilter((val = 'one_year'))"
            :disabled="revloader" width="40px" outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
            <span :style="`color:${daytabval == 'one_year' ? '#3B82F6' : 'black'};`" class="caption">1Y</span>
          </v-card>
          <!-- <v-menu v-model="menu2" :close-on-content-click="false" :nudge-left="250" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-card v-bind="attrs" v-on="on" :color="`${daytabval == 'custom' ? '#EFF6FF' : ''}`" width="48px" outlined
                class="mt-2 py-2 elevation-0 rounded-r-lg rounded-0 text-center">
                <span :style="`color:${daytabval == 'custom' ? '#3B82F6' : 'black'
                  };`" class="caption">CUST</span>
              </v-card>
            </template>
            <v-date-picker v-model="dateSelect" :max="maxDate" type="month"
              @input="(menu2 = false), dayCustom()"></v-date-picker>
          </v-menu> -->
          <v-menu v-model="menu22" :close-on-content-click="false" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <!-- <v-tooltip v-bind="attrs" v-on="on" open-delay="400" color="black" bottom>
                <template v-slot:activator="{ on, attrs }"> -->
              <v-card v-bind="attrs" v-on="on" :color="`${daytabval == 'custom' ? '#EFF6FF' : ''}`" :disabled="revloader"
                width="48px" outlined class="mt-2 py-2 elevation-0 rounded-r-lg rounded-0 text-center">
                <span :style="`color:${daytabval == 'custom' ? '#3B82F6' : 'black'
                  };`" class="caption">CUST</span>
              </v-card>
              <!-- </template>
                <span>custom date</span>
              </v-tooltip> -->
            </template>
            <v-card width="580px">
              <v-row no-gutters>
                <v-col cols="6">
                  <v-date-picker color="#3B82F6" v-model="dateSelect2" :max="maxDate2"></v-date-picker>
                </v-col>
                <v-col cols="6">
                  <v-date-picker color="#3B82F6" v-model="dateSelectto" :min="dateSelect2" :max="maxDate2"
                    @input="(menu22 = false), (menu2to = false), dayCustom()"></v-date-picker>
                </v-col>
              </v-row>
            </v-card>
          </v-menu>
          <!-- <v-menu ref="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition"
            offset-y max-width="290px" min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field color="#3B82F6" class="rounded-lg mt-2" style="max-width: 180px;" outlined dense hide-details v-model="date" label="Month"
                prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker :min="past" :max="latest" @change="monthChange()" v-model="date" type="month" no-title
              scrollable>
            </v-date-picker>
          </v-menu> -->
        </v-toolbar>
        <div class="px-4 pt-2">
          <div class="pt-2">
            <v-tabs v-model="revtab" flat background-color="transparent" color="#3B82F6" active-class="font-weight-bold">

              <v-tab @click="(menu22 = false), (menu2to = false)">
                <v-badge bordered color="#3B82F6" :value="revenuedaydata.length" :content="revenuedaydata.length">
                  <span>Day wise</span>
                </v-badge>
              </v-tab>
              <v-tab @click="menu2 = false">
                <v-badge bordered color="#3B82F6" :value="filrevenuedata.length" :content="filrevenuedata.length">
                  <span>Client wise</span>
                </v-badge>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="revtab">
              <v-tab-item>
                <div>
                  <v-data-table height="51vh" dense fixed-header fixed-footer class="dataTable"
                    style="border: 1px solid rgba(0, 0, 0, 0.12)" must-sort :items-per-page="100" :footer-props="{
                      'items-per-page-options': [10, 30, 50, 100, -1],
                    }" :loading="revloader" :headers="dayheaders" :items="revenuedaydata" :sort-by="['TRADE_DATE']"
                    :sort-desc="[false]" :search="daysearchText">
                    <template v-slot:[`body.append`]="{ items }">
                      <!-- <v-divider></v-divider> -->
                      <tr v-if="!revloader">
                        <th colspan="5"> Total :</th>
                        <th class="text-right" colspan="1">{{ subTotal(items, 'ownbrk') }}</th>
                        <!-- <th class="text-right" colspan="1">{{ dayibtownbrk.toFixed(2) }}</th> -->
                        <th class="text-right" colspan="1">{{ subTotal(items, 'incentive_amt') }}</th>
                        <!-- <th class="text-right" colspan="1">{{ dayibtincamt.toFixed(2) }}</th> -->
                      </tr>
                      <!--dayownbrk dayincamt -->
                    </template>
                    <template v-slot:[`item.incentive_amt`]="{ item }">
                      <span>
                        {{ item.incentive_amt?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.OWN_MCX`]="{ item }">
                      <span>
                        {{ item.OWN_MCX?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.OWN_NSE_FNO`]="{ item }">
                      <span>
                        {{ item.OWN_NSE_FNO?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.OWN_NSE_CASH`]="{ item }">
                      <span>
                        {{ item.OWN_NSE_CASH?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.ownbrk`]="{ item }">
                      <span>
                        {{ item.ownbrk?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.seg`]="{ item }">

                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            {{ (
                              item.OWN_BSE_CASH + item.OWN_BSE_COM + item.OWN_CD_NSE + item.OWN_ICEX + item.OWN_MF_BSE +
                              item.OWN_NSE_COM + item.OWN_NSE_DLY)?.toFixed(2)
                            }}
                          </span>
                          <!-- <v-btn style="border-bottom: thin solid grey;" class="pa-0 ml-n4 elevation-0" text plain>
                          </v-btn> -->
                        </template>
                        <v-list dense height="300px">
                          <v-list-item>
                            <v-list-item-title>BSE CASH : {{ item.OWN_BSE_CASH }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>BSE COM : {{ item.OWN_BSE_COM }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>CD NSE : {{ item.OWN_CD_NSE }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>ICEX : {{ item.OWN_ICEX }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>MF BSE : {{ item.OWN_MF_BSE }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>NSE COM : {{ item.OWN_NSE_COM }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>NSE DLY : {{ item.OWN_NSE_DLY }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                    <template v-slot:[`item.IBT_OWN_BRK`]="{ item }">

                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">
                            {{ item.IBT_OWN_BRK > 0 ? (item.IBT_OWN_BRK).toFixed(2) : '0.00' }}
                          </span>
                        </template>
                        <v-list dense height="300px">
                          <v-card class="elevation-0">

                            <v-list-item>
                              <v-list-item-title>BSE CASH : {{ item.IBT_OWN_BSE_CASH }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>BSE COM : {{ item.IBT_OWN_BSE_COM }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>CD NSE : {{ item.IBT_OWN_CD_NSE }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>ICEX : {{ item.IBT_OWN_ICEX }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>MF BSE : {{ item.IBT_OWN_MF_BSE }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>NSE CASH : {{ item.IBT_OWN_NSE_CASH }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>NSE COM : {{ item.IBT_OWN_NSE_COM }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>NSE DLY : {{ item.IBT_OWN_NSE_DLY }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>NSE FNO : {{ item.IBT_OWN_NSE_FNO }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>MCX : {{ item.IBT_OWN_MCX }}</v-list-item-title>
                            </v-list-item>
                          </v-card>

                        </v-list>

                      </v-menu>
                    </template>
                    <template v-slot:[`item.ibt_incentive_amt`]="{ item }">
                      <span>
                        {{ item.ibt_incentive_amt > 0 ? (item.ibt_incentive_amt).toFixed(2) : '0.00' }}
                      </span>
                    </template>
                  </v-data-table>
                </div>
              </v-tab-item>
              <v-tab-item>
                <div>
                  <v-data-table @click:row="getDeepdata" height="51vh" dense fixed-header fixed-footer class="dataTable"
                    style="border: 1px solid rgba(0, 0, 0, 0.12)" must-sort :items-per-page="100" :footer-props="{
                      'items-per-page-options': [10, 30, 50, 100, -1],
                    }" :loading="revloader" :headers="headers" :items="filrevenuedata" :sort-by="filrevenue"
                    :sort-desc="[true]" :search="searchText">
                    <template v-slot:[`body.append`]>
                      <!-- <v-divider></v-divider> -->
                      <tr v-if="!revloader">
                        <th colspan="6"> Total :</th>
                        <th class="text-right" colspan="1">{{ ownbrk?.toFixed(2) }}</th>
                        <!-- <th class="text-right" colspan="1">{{ ibt_ownbrk?.toFixed(2) }}</th> -->
                        <th class="text-right" colspan="1">{{ incentive_amt?.toFixed(2) }}</th>
                        <!-- <th class="text-right" colspan="1">{{ ibt_incentive_amt?.toFixed(2) }}</th> -->

                      </tr>
                    </template>
                    <template v-slot:[`item.CLIENT_ID`]="{ item }">
                      <span>{{ item.CLIENT_ID }}
                        <v-chip x-small color="#EFF6FF" style="color: #3B82F6;"
                          v-if="item.rem_code != '' ? item.rem_code : item.rm_code != '' ? item.rm_code : ''">
                          {{ item.rem_code != '' ? item.rem_code : item.rm_code != '' ? item.rm_code : ''
                          }}
                        </v-chip>
                      </span>
                    </template>
                    <template v-slot:[`item.incentive_amt`]="{ item }">
                      <span>
                        {{ item.incentive_amt?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.OWN_MCX`]="{ item }">
                      <span>
                        {{ item.OWN_MCX?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.OWN_NSE_FNO`]="{ item }">
                      <span>
                        {{ item.OWN_NSE_FNO?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.OWN_NSE_CASH`]="{ item }">
                      <span>
                        {{ item.OWN_NSE_CASH?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.ownbrk`]="{ item }">
                      <span>
                        {{ item.ownbrk?.toFixed(2) }}
                      </span>
                    </template>
                    <template v-slot:[`item.IBT_OWN_BRK`]="{ item }">

                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }"><span v-bind="attrs" v-on="on">
                            {{ item.IBT_OWN_BRK > 0 ? (item.IBT_OWN_BRK).toFixed(2) : '0.00' }}
                          </span>
                        </template>
                        <v-list dense height="300px">
                          <v-card class="elevation-0">

                            <v-list-item>
                              <v-list-item-title>BSE CASH : {{ item.IBT_OWN_BSE_CASH }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>BSE COM : {{ item.IBT_OWN_BSE_COM }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>CD NSE : {{ item.IBT_OWN_CD_NSE }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>ICEX : {{ item.IBT_OWN_ICEX }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>MF BSE : {{ item.IBT_OWN_MF_BSE }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>NSE CASH : {{ item.IBT_OWN_NSE_CASH }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>NSE COM : {{ item.IBT_OWN_NSE_COM }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>NSE DLY : {{ item.IBT_OWN_NSE_DLY }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>NSE FNO : {{ item.IBT_OWN_NSE_FNO }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-title>MCX : {{ item.IBT_OWN_MCX }}</v-list-item-title>
                            </v-list-item>
                          </v-card>

                        </v-list>

                      </v-menu>
                    </template>
                    <template v-slot:[`item.ibt_incentive_amt`]="{ item }">
                      <span>
                        {{ item.ibt_incentive_amt > 0 ? (item.ibt_incentive_amt).toFixed(2) : '0.00' }}
                      </span>
                    </template>
                    <template v-slot:[`item.seg`]="{ item }">

                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            {{ (
                              item.OWN_BSE_CASH + item.OWN_BSE_COM + item.OWN_CD_NSE + item.OWN_ICEX + item.OWN_MF_BSE +
                              item.OWN_NSE_COM + item.OWN_NSE_DLY)?.toFixed(2)
                            }}
                          </span>
                          <!-- <v-btn style="border-bottom: thin solid grey;" class="pa-0 ml-n4 elevation-0" text plain>
                          </v-btn> -->
                        </template>
                        <v-list dense height="300px">
                          <v-list-item>
                            <v-list-item-title>BSE CASH : {{ item.OWN_BSE_CASH }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>BSE COM : {{ item.OWN_BSE_COM }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>CD NSE : {{ item.OWN_CD_NSE }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>ICEX : {{ item.OWN_ICEX }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>MF BSE : {{ item.OWN_MF_BSE }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>NSE COM : {{ item.OWN_NSE_COM }}</v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>NSE DLY : {{ item.OWN_NSE_DLY }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </div>
    </v-container>
    <v-dialog v-model="profileVisible" hide-overlay class="elevation-0" width="65%">
      <v-card class="trdditl">
        <v-data-table style="border: 1px solid #efeef3;" class="elevation-0" dense :headers="orderheaders" fixed-header
          :items="revenueindata" :items-per-page="100" :footer-props="{
            'items-per-page-options': [10, 30, 50, 100, -1],
          }" height="calc(100vh - 400px)" :sort-by="['TRADE_DATE']" :sort-desc="[true]">
          <template v-slot:top>
            <v-toolbar flat dense class="px-4">
              <v-toolbar-title>{{ revenueindata[0].CLIENT_ID }}
              </v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-btn text icon @click="profileVisible = false">
                <v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-divider></v-divider>
          </template>
          <template v-slot:[`item.CLIENT_ID`]="{ item }">
            <span>{{ item.CLIENT_ID }}
              <v-chip x-small color="#EFF6FF" style="color: #3B82F6;"
                v-if="item.rem_code != '' ? item.rem_code : item.rm_code != '' ? item.rm_code : ''">
                {{ item.rem_code != '' ? item.rem_code : item.rm_code != '' ? item.rm_code : '' }}
              </v-chip>
            </span>
          </template>
          <template v-slot:[`item.rm_code`]="{ item }">
            <span>
              {{ item.rm_code == 'nan' ? null : item.rm_code }}
            </span>
          </template>
          <template v-slot:[`item.ownbrk`]="{ item }">
            <span>
              {{ item.ownbrk?.toFixed(2) }}
            </span>
          </template>
          <template v-slot:[`item.incentive_amt`]="{ item }">
            <span>
              {{ item.incentive_amt?.toFixed(2) }}
            </span>
          </template>
          <template v-slot:[`item.IBT_OWN_BRK`]="{ item }">
            <span>
              {{ item.IBT_OWN_BRK > 0 ? (item.IBT_OWN_BRK).toFixed(2) : '0.00' }}
            </span>
          </template>
          <template v-slot:[`item.ibt_incentive_amt`]="{ item }">
            <span>
              {{ item.ibt_incentive_amt > 0 ? (item.ibt_incentive_amt).toFixed(2) : '0.00' }}
            </span>
          </template>
        </v-data-table>
      </v-card>

    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import { apiurl } from "../apiUrl";
export default {
  data() {
    return {
      incentive_amt: 0,
      ownbrk: 0,
      ibt_incentive_amt: 0,
      ibt_ownbrk: 0,
      dayibtownbrk: 0,
      dayibtincamt: 0,
      dayincamt: 0,
      dayownbrk: 0,

      filrevenue: ['incentive_amt'],

      revtab: 0,
      snackbar: false,

      menu2: false,
      menu22: false,
      menu2to: false,

      dateSelect: new Date().toISOString().substr(0, 7),
      maxDate: new Date().toISOString().substr(0, 7),

      dateSelectto: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dateSelect2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      maxDate2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      errMsg: "",

      searchText: "",
      daysearchText: "",

      daytabval: "current_month",
      clientstype: 'All',
      clisimodel: 'All',
      branchcode: null,
      revloader: true,
      revenuedata: [],
      filrevenuedata: [],
      revenuedaydata: [],
      revenueindata: [],
      date: new Date().toISOString().substr(0, 7),
      // date: '2023-05',
      latest: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 7),
      past: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 7),

      profileVisible: false,
      today: new Date().getFullYear() + '-' + ("0" + (new Date().getMonth() + 1)).slice(-2) + '-' + ("0" + new Date().getDate()).slice(-2),
      modeis: null,
    };
  },
  created() {
    let modeis = localStorage.getItem('mode');
    if (modeis == 'RM') {
      this.modeis = 'r';
      this.clientstype = 'RM';
    } else {
      this.modeis = 'b';
      this.clientstype = 'All';
    }

    this.branchcode = localStorage.getItem('brcode')
  },
  mounted() {
    this.enddate = new Date(this.date.slice(4), this.date.slice(-2), 0).getDate();
    this.getRevenuedata();
    this.getDayrevenue();
  },

  methods: {
    monthChange() {
      this.revloader = true;
      this.revenuedata = [];
      this.filrevenuedata = [];
      this.revenueindata = [];
      this.revenuedaydata = [];
      this.$refs.menu.save(this.date);
      this.enddate = new Date(this.date.slice(4), this.date.slice(-2), 0).getDate();
      this.getRevenuedata();
    },

    getRevenuedata() {
      this.revenuedata = [];
      this.filrevenuedata = [];
      let data;
      if (this.daytabval == 'custom') {
        data = JSON.stringify({
          "branch_code": this.branchcode,
          "values": this.daytabval,
          "start_date": this.dateSelect2,
          "end_date": this.dateSelectto
        });
      } else {
        data = JSON.stringify({
          "branch_code": this.branchcode,
          "values": this.daytabval,
          "start_date": '',
          "end_date": ''
        });
      }

      let config = {
        method: 'post',
        url: `${apiurl}/getMonthlySameRow`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          if (response.data.brk_data.length > 0) {
            if (response.data.ibt_data.length > 0) {
              let brk_data = response.data.brk_data;
              let ibt = response.data.ibt_data;

              for (let q = 0; q < ibt.length; q++) {
                let index = brk_data.findIndex(x => x.CLIENT_ID === ibt[q].CLIENT_ID);
                brk_data[index] = { ...brk_data[index], ...ibt[q] };
                brk_data[index].ownbrk = brk_data[index].ownbrk + brk_data[index].IBT_OWN_BRK;
                brk_data[index].incentive_amt = brk_data[index].incentive_amt + brk_data[index].ibt_incentive_amt;
              }
              axiosThis.revenuedata = brk_data;
            } else {
              axiosThis.revenuedata = response.data.brk_data;
            }

            axiosThis.clientFilter();
          }
          axiosThis.revloader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDeepdata(item) {
      this.revloader = true;
      this.revenueindata = [];
      let data;
      if (this.daytabval == 'custom') {
        data = JSON.stringify({
          "branch_code": this.branchcode,
          "values": this.daytabval,
          "Client_id": item.CLIENT_ID,
          "start_date": this.dateSelect2,
          "end_date": this.dateSelectto
        });
      } else {
        data = JSON.stringify({
          "branch_code": this.branchcode,
          "values": this.daytabval,
          "Client_id": item.CLIENT_ID,
          "start_date": '',
          "end_date": ''
        });
      }
      let config = {
        method: 'post',
        url: `${apiurl}/getMonthlyData`,

        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          if (response.data.brk_data.length > 0) {
            if (response.data.ibt_data.length > 0) {
              let brk_data = response.data.brk_data;
              let ibt = response.data.ibt_data;

              for (let q = 0; q < ibt.length; q++) {
                let index = brk_data.findIndex(x => x.TRADE_DATE === ibt[q].IBT_TRADE_DATE);
                brk_data[index] = { ...brk_data[index], ...ibt[q] }
              }
              axiosThis.revenueindata = brk_data;
            } else {
              axiosThis.revenueindata = response.data.brk_data;
            }
            axiosThis.profileVisible = true;
            axiosThis.revloader = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDayrevenue() {
      this.revenuedaydata = [];
      let data;
      if (this.daytabval == 'custom') {
        data = JSON.stringify({
          "branch_code": this.branchcode,
          "values": this.daytabval,
          "start_date": this.dateSelect2,
          "end_date": this.dateSelectto
        });
      } else {
        data = JSON.stringify({
          "branch_code": this.branchcode,
          "values": this.daytabval,
          "start_date": '',
          "end_date": ''
        });
      }

      let config = {
        method: 'post',
        url: `${apiurl}/getDailyCumulative`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          if (response.data.brk_data.length > 0) {
            if (response.data.ibt_data.length > 0) {
              let brk_data = response.data.brk_data;
              let ibt = response.data.ibt_data;

              for (let q = 0; q < ibt.length; q++) {
                let index = brk_data.findIndex(x => x.TRADE_DATE === ibt[q].IBT_TRADE_DATE);
                brk_data[index] = { ...brk_data[index], ...ibt[q] };
                brk_data[index].ownbrk = brk_data[index].ownbrk + brk_data[index].IBT_OWN_BRK;
                brk_data[index].incentive_amt = brk_data[index].incentive_amt + brk_data[index].ibt_incentive_amt;
              }
              axiosThis.revenuedaydata = brk_data;
            } else {
              axiosThis.revenuedaydata = response.data.brk_data;
            }
            this.dayownbrk = this.revenuedaydata.reduce((n, { ownbrk }) => n + ownbrk, 0)
            this.dayincamt = this.revenuedaydata.reduce((n, { incentive_amt }) => n + incentive_amt, 0)
            let arrbrk = [];
            let arrinc = [];
            for (let d = 0; d < this.revenuedaydata.length; d++) {
              arrbrk.push(this.revenuedaydata[d].IBT_OWN_BRK)
              arrinc.push(this.revenuedaydata[d].ibt_incentive_amt)
            }
            this.dayibtownbrk = arrbrk.reduce(function (s, v) { return s + (v || 0); }, 0);
            this.dayibtincamt = arrinc.reduce(function (s, v) { return s + (v || 0); }, 0);
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },

    daytableFilter(val) {
      if (val != this.daytabval) {
        this.revloader = true;
        this.daytabval = val;
        this.getDayrevenue();
        this.getRevenuedata();
      }
    },

    dayCustom() {
      this.revloader = true;
      this.daytabval = 'custom';
      this.getDayrevenue();
      this.getRevenuedata();
    },
    subTotal(items, column) {
      return items.reduce((sum, item) => sum + item[column], 0)?.toFixed(2);
    },
    clientFilter() {
      this.revloader = true;
      this.filrevenuedata = [];
      let modeis = localStorage.getItem('mode');

      if (this.clientstype == 'All' || modeis == 'RM') {
        this.filrevenuedata = this.revenuedata;
      } else {
        this.clisitems = [];
        this.clisitems = ['All'];
        this.clisimodel = 'All'
        for (let e = 0; e < this.revenuedata.length; e++) {
          if (this.clientstype == 'AP' && this.revenuedata[e].rem_code != "") {
            this.revenuedata[e]['codeis'] = this.revenuedata[e].rem_code;
            this.filrevenuedata.push(this.revenuedata[e])
          } else if (this.clientstype == 'RM' && this.revenuedata[e].rm_code != "" && this.revenuedata[e].rm_code != "" && this.revenuedata[e].rem_code == "") {
            this.revenuedata[e]['codeis'] = this.revenuedata[e].rm_code;
            this.filrevenuedata.push(this.revenuedata[e])
          } else if (this.clientstype == 'Direct' && this.revenuedata[e].rem_code == "" && (this.revenuedata[e].rm_code == "" || this.revenuedata[e].rm_code == "")) {
            this.filrevenuedata.push(this.revenuedata[e])
          }
        }
        let clis = this.getUniqueListBy(this.filrevenuedata, 'codeis')

        for (let f = 0; f < clis.length; f++) {
          this.clisitems.push(clis[f].codeis.toUpperCase());
        }
        this.clisitems.sort();
      }
      let arrbrk = [];
      let arrinc = [];
      for (let d = 0; d < this.filrevenuedata.length; d++) {
        arrbrk.push(this.filrevenuedata[d].IBT_OWN_BRK)
        arrinc.push(this.filrevenuedata[d].ibt_incentive_amt)
      }
      this.ibt_ownbrk = arrbrk.reduce(function (s, v) { return s + (v || 0); }, 0);
      this.ibt_incentive_amt = arrinc.reduce(function (s, v) { return s + (v || 0); }, 0);
      this.ownbrk = this.filrevenuedata.reduce((n, { ownbrk }) => n + ownbrk, 0)
      this.incentive_amt = this.filrevenuedata.reduce((n, { incentive_amt }) => n + incentive_amt, 0)
      this.revloader = false;
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()]
    },
    clisFilter() {
      this.revloader = true;
      let modeis = localStorage.getItem('mode');

      if (this.clisimodel == 'All' || modeis == 'RM') {
        this.clientFilter();
      } else {
        this.filrevenuedata = [];
        for (let o = 0; o < this.revenuedata.length; o++) {
          if (this.revenuedata[o].codeis == this.clisimodel) {
            this.filrevenuedata.push(this.revenuedata[o])
          }
        }
        this.ownbrk = this.filrevenuedata.reduce((n, { ownbrk }) => n + ownbrk, 0)
        this.incentive_amt = this.filrevenuedata.reduce((n, { incentive_amt }) => n + incentive_amt, 0)
        this.ibt_ownbrk = this.filrevenuedata.reduce((n, { IBT_OWN_BRK }) => n + IBT_OWN_BRK, 0)
        this.ibt_incentive_amt = this.filrevenuedata.reduce((n, { ibt_incentive_amt }) => n + ibt_incentive_amt, 0)

      }
      this.revloader = false;
    }
  },

  computed: {
    headers() {
      return [
        { text: "Client", value: "CLIENT_ID" },
        // { text: "REM/RM", value: "rem_code", sortable: false },
        { text: "Days", value: "no_of_days" },
        { text: "CASH", value: "OWN_NSE_CASH", sortable: false, align: 'right' },
        { text: "FNO", value: "OWN_NSE_FNO", sortable: false, align: 'right' },
        { text: "MCX", value: "OWN_MCX", sortable: false, align: 'right' },
        { text: "Seg", value: "seg", sortable: false, align: 'right' },
        { text: "Brokrage", value: "ownbrk", align: 'right' },
        // { text: "IBT", value: "IBT_OWN_BRK", align: 'right' },
        { text: "Revenue credit", value: "incentive_amt", align: 'right' },
        // { text: "IBT-RC", value: "ibt_incentive_amt", align: 'right' },

      ];
    },
    dayheaders() {
      return [
        { text: "Date", value: "TRADE_DATE" },
        // { text: "Client", value: "CLIENT_ID" },
        { text: "CASH", value: "OWN_NSE_CASH", sortable: false, align: 'right' },
        { text: "FNO", value: "OWN_NSE_FNO", sortable: false, align: 'right' },
        { text: "MCX", value: "OWN_MCX", sortable: false, align: 'right' },
        { text: "Seg", value: "seg", sortable: false, align: 'right' },
        { text: "Brokrage", value: "ownbrk", align: 'right' },
        // { text: "IBT", value: "IBT_OWN_BRK", align: 'right' },
        { text: "Revenue credit", value: "incentive_amt", align: 'right' },
        // { text: "IBT-RC", value: "ibt_incentive_amt", align: 'right' },

      ];
    },
    orderheaders() {
      return [
        { text: "Date", value: "TRADE_DATE" },
        { text: "Client", value: "CLIENT_ID" },
        { text: "Days", value: "no_of_days" },
        // { text: "REM/RM", value: "rem_code", sortable: false },
        { text: "Brokrage", value: "ownbrk", align: 'right' },
        { text: "IBT", value: "IBT_OWN_BRK", align: 'right' },
        { text: "Revenue credit", value: "incentive_amt", align: 'right' },
        { text: "IBT-RC", value: "ibt_incentive_amt", align: 'right' },
        { text: "Percentage", value: "incentive_per", sortable: false, align: 'right', },
      ];
    },
  },
};
</script>

<style>
/* .headline { */
/* font-family: 'DM Sans' !important; */
/* font-weight: 500; */
/* } */
.trdditl::-webkit-scrollbar {
  width: 6px;
}

.trdditl::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.trdditl::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.6);
  border-radius: 16px;
}

.toolbar .v-toolbar__content {
  padding: 0 !important;
}

.datedetailshead .v-data-table-header__sort-badge {
  display: none !important;
}
</style>
<style lang="scss">
.colums {
  position: static;
  float: left;
}
</style>
